module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-right-white-5eedccf1.svg";